import styled from 'styled-components';

import addIcon from "../../../icons/IconAdd.png";
import addIconHover from "../../../icons/IconAddHover.png";
import deleteIcon from "../../../icons/IconTooltipDelete.png";
import deleteIconHover from "../../../icons/IconTooltipDeleteHover.png";
import { Icon_SVG_24x24, Icon_SVG_32x32, SVG_Container_50x50 } from '../common/Buttons';


const FB_Grid_Wrappwer_WIDTH  = 1200;
const FB_Grid_Wrappwer_HEIGHT = 520;


export const FBGridWrapper = styled.div`
  position: fixed;
  top: calc(50% - ${FB_Grid_Wrappwer_HEIGHT / 2}px);
  left: calc(50% - ${FB_Grid_Wrappwer_WIDTH / 2}px);
  transform: translate(-50%, -50%);
  z-index: 10000;
  width: ${FB_Grid_Wrappwer_WIDTH}px;
  height: ${FB_Grid_Wrappwer_HEIGHT}px;
  background: #ffffff;
  border: 2px solid #4eab00;
  box-sizing: border-box;
  box-sizing: content-box;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  padding: 10px;
`;


export const FPGridContainer = styled.div`
  display: grid;
  grid-template-areas:
    'header'
    'subheader'
    'body'
    'footer';
  grid-template-rows: 24px 24px calc(100% - 108px) 60px;
  grid-gap: 10px;
  height: auto;
`;


export const FPGridHeader = styled.div`
  grid-area: header;
  color: black;
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  text-align: start;
  text-transform: uppercase;
`;


export const FPGridSubHeader = styled.div`
  grid-area: subheader;
  color: black;
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  text-align: start;
  text-transform: uppercase;
`;


export const GridContainer = styled.div`
  grid-area: body;
  display: grid;
  grid-template-columns: 60% 40%; /* Two columns with equal width */
  grid-template-rows: repeat(3, 1fr); /* Four rows with equal height */
  gap: 10px; /* Add some gap between the columns and rows */
`;


export const FPGridFooter = styled.div`
  display: grid;
  grid-area: footer;
  line-height: 50px;
  grid-template-columns: 50% 50%; /* Two columns with equal width */
`;


export const FirstColumn = styled.div`
  grid-row: span 3; /* This column will span all 3 rows */
  min-height: calc(${FB_Grid_Wrappwer_HEIGHT}px - 160px);
  max-height: calc(${FB_Grid_Wrappwer_HEIGHT}px - 160px);
  overflow-y: auto;
`;


export const SecondColumn = styled.div`
  grid-row: span 3; /* This column will span 3 rows */
  overflow-y: scroll;
  min-height: calc(${FB_Grid_Wrappwer_HEIGHT}px - 160px);
  max-height: calc(${FB_Grid_Wrappwer_HEIGHT}px - 160px);
`;


/* Common row styles (adjust as needed) */
export const GridRow = styled.div`
  padding: 0 0 10px 0;
`;


export const GridInputContainer = styled.div`
  display: grid;
  grid-template-columns: 30% 20% 40% 5%;
  gap: 10px;
  height: '38px';
`;


export const GridRowSpanThree = styled.div`
  padding: 0 0 10px 0;
  margin-right: 10px;
  grid-row: span 3; /* This specific row will span 3 rows */
`;


export const GridButtonWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Three columns with equal width */
  gap: 10px; /* Add some gap between the buttons */
`;


export const GridButtonContainer = styled.div`
  width: 100%; /* Buttons will take up the full width of the column */
  height: 42px; /* Set a fixed height for the buttons */
  line-height: 42px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
}`;


export const SaveButtonContainer = styled.div`
  display: grid;
  justify-items: end;
`;


export const AddFilterButton = styled.button`
  display: inline-block;
  vertical-align: bottom;
  width: 20px;
  height: 20px;
  padding: 0;
  border: none;
  align-content: center;
  align-items: center;
  background-size: 20px;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${ addIcon });

  &:hover {
    cursor: pointer;
    background-image: url(${ addIconHover });
  }
`;


export const DeleteFilterButton = styled.button`
  display: inline-block;
  width: 20px;
  height: 30px;
  padding: 0;
  border: none;
  align-content: center;
  align-items: center;
  background-size: 24px;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center bottom;
  background-image: url(${ deleteIcon });

  svg:hover {
    stroke: #7bc62d;
  }

  &:hover {
    cursor: pointer;
    // background-image: url(${ deleteIconHover });

    svg path {
      stroke: green;
    }
  }
`;

export const DeleteFilter_SVG = styled(Icon_SVG_24x24)`
  width: 100%;
  height: 38px;
  flex-basis: 38px;
  display: flex;
  margin-left: auto;

  align-content: center;
  align-items: center;
  justify-content: center;

  svg {
    width: 24px;
    height: 24px;
  }
`;

export const AddFilter_SVG = styled(SVG_Container_50x50)`
  display: inline-block;
  vertical-align: text-bottom;
  width: 20px;
  height: 20px;
  flex-basis: 20px;
  align-content: center;
  align-items: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const Calendar_SVG = styled(Icon_SVG_24x24)`
  width: 100%;
  height: 38px;
  flex-basis: 38px;
  display: flex;
  margin-left: auto;

  align-content: center;
  align-items: center;

  svg {
    width: 24px;
    height: 24px;
  }
`;
